import { render, staticRenderFns } from "./AppMultiTabDropdown.vue?vue&type=template&id=0985435e&scoped=true"
import script from "./AppMultiTabDropdown.vue?vue&type=script&lang=js"
export * from "./AppMultiTabDropdown.vue?vue&type=script&lang=js"
import style0 from "./AppMultiTabDropdown.vue?vue&type=style&index=0&id=0985435e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985435e",
  null
  
)

export default component.exports